import DocumentUploadConfiguration from "./documentUploadConfiguration";
import UserRequestFileUploadConfiguration from "./userRequestFileUploadConfiguration";

export default class FileUploadSettings {
    documents = new DocumentUploadConfiguration();
    userRequests = new UserRequestFileUploadConfiguration();
}